export function isBlank(value: any): boolean {
  return value === null || value === undefined || value === "";
}

export function isTruthy(value: any): boolean {
  return value === true || value === "true" || value === 1 || value === "1" || value === "t" || value === "yes" || value === "y";
}

export function ucFirst(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function getLastOrNull(array: any[]): any {
  if (array.length === 0) {
    return null;
  }
  return array[array.length - 1];
}

export function getLastItems<T>(array: T[], count: number): T[] {
  return array.slice(-count);
}

export function roundToTwoDecimals(value: number): number {
  return Math.round(value * 100) / 100;
}

export function roundToOneDecimal(value: number): number {
  return Math.round(value * 10) / 10;
}

export function makeLongStringPreview(str: string, length: number | null = null): string {
  if (length === null) {
    length = str.length / 3;
  }

  if (str.length <= length) {
    return str;
  }
  return str.substring(0, length) + "..." + str.substring(str.length - length);
}

export function getMean(array: number[]): number {
  return array.reduce((acc, val) => acc + val, 0) / array.length;
}

export function getMedian(array: number[]): number {
  const sorted = array.sort((a, b) => a - b);
  const middle = Math.floor(sorted.length / 2);
  return sorted[middle];
}

/**
 * Safely extracts error message from any error object
 * @param error - Any error object
 * @returns Error message string
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  if (error && typeof error === 'object' && 'message' in error) {
    return String(error.message);
  }
  return 'Unknown error';
}